import React from "react";

const HIGHLIGHTED_TERMS = [
  "application moderne réellement déployée",
  "location d’assises et de mobilier événementiel",
  "produits, conseils et recommandations",
  "expérience simple et pédagogique",
  "demandes de contact et de devis",
  "Conception de l’architecture full-stack",
  "catalogue de 26 produits répartis dans 7 catégories",
  "guides d’entretien détaillés",
  "Product Finder",
  "API REST Symfony",
  "Doctrine / PostgreSQL",
  "responsive mobile, l’accessibilité et la stabilité sur Safari/iPhone",
  "CI GitLab",
  "gestion des secrets",
  "présenter l’activité",
  "particuliers",
  "EasyAdmin",
  "HTTPS",
  "formulaire de contact et de demande de devis",
  "prise de contact et de rendez-vous en ligne",
  "gestion administrable du contenu",
  "location d’assises et de mobilier",
  "migrations de base de données",
  "formulaire de contact sécurisé",
  "site web sur mesure",
  "site web responsive",
  "présence web complète",
  "offres et des ambiances",
  "prise de rendez-vous",
  "référencement local",
  "identité visuelle",
  "charte graphique",
  "outil de gestion",
  "agenda en ligne",
  "mise en ligne",
  "back-office",
  "PostgreSQL",
  "Tailwind CSS",
  "Node.js",
  "Symfony",
  "Docker",
  "Nginx",
  "React",
  "logo",
  "VPS",
  "site web",
];

const normalizedTerms = new Set(
  HIGHLIGHTED_TERMS.map((term) => term.toLocaleLowerCase("fr"))
);

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const pattern = new RegExp(
  `(${[...HIGHLIGHTED_TERMS]
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp)
    .join("|")})`,
  "gi"
);

function ProjectText({ children }) {
  if (typeof children !== "string") {
    return children;
  }

  return children.split(pattern).map((part, index) =>
    normalizedTerms.has(part.toLocaleLowerCase("fr")) ? (
      <strong key={`${part}-${index}`} className="font-semibold text-ink">
        {part}
      </strong>
    ) : (
      part
    )
  );
}

export default ProjectText;
